import {
  ArrowUpRightIc,
  CommentIc,
  Dialog,
  Image,
  MapPinIc,
  ThumbIc,
  Video,
} from "@/components/Elements";
import { useEffect, useState } from "react";
import { mapStringToLocation, useLocation } from "@/hooks/useLocation";
import { themeTextColor } from "@/utils/colorConstant";
import { AdvertModel } from "../../types";
import { ActionBtn } from "@/features/misc/components";
import { useFormat } from "@/hooks";
import useToggle from "@/hooks/useToggle";
import { AdvertDetail } from "./AdvertDetail";

export const Advert = ({ advertDetail }: { advertDetail: AdvertModel }) => {
  const {
    createdOn: createdOn,
    description,
    files,
    likeCount: noOfLikes,
    commentCount,
    postLocation,
    price,
    discount,
  } = advertDetail;
  const [address, setAddress] = useState("");
  const { getAddressDetail, geocoder } = useLocation();
  const { formatCost } = useFormat();
  const { show: showAdvertModal, toggle: toggleAdvertModal } = useToggle();

  useEffect(() => {
    if (postLocation) {
      (async () => {
        const location = mapStringToLocation(postLocation);
        if (location) {
          const { postCode } = await getAddressDetail(location);
          setAddress(postCode ?? "");
        }
      })();
    }
  }, [geocoder, postLocation]);

  return (
    <>
      <div className="w-full">
        {files?.length > 0 && (
          <div className="w-full h-60">
            {files[0].fileUrl?.includes(".mp4") ? (
              <Video apiSrc={files[0].fileUrl} className="w-full h-full" />
            ) : (
              <Image
                src={files[0].fileUrl}
                className="w-full h-full"
                isApiUrl
              />
            )}
          </div>
        )}
        <p className="truncate">{description}</p>
        <div className="flex justify-between py-5 border-b">
          <ActionBtn text={noOfLikes}>
            <ThumbIc className={`w-6 h-6 ${themeTextColor}`} />
          </ActionBtn>
          <ActionBtn text={address}>
            <MapPinIc className={`w-6 h-6  ${themeTextColor}`} />
          </ActionBtn>
          <ActionBtn text={commentCount}>
            <CommentIc className={`w-6 h-6  ${themeTextColor}`} />
          </ActionBtn>
        </div>
        <div className="mt-7 border-y border-black border-dotted flex justify-between py-2">
          <div className="text-lg font-bold">Price: {formatCost(price)}</div>
          <div className="text-lg font-bold">
            Discount: {formatCost(discount)}
          </div>
          <div className="h-10 w-10 bg-black flex items-center justify-center">
            <button onClick={toggleAdvertModal}>
              <ArrowUpRightIc className="text-white h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
      {showAdvertModal && (
        <Dialog isOpen={showAdvertModal} onClose={toggleAdvertModal}>
          <AdvertDetail advertDetail={advertDetail} />
        </Dialog>
      )}
    </>
  );
};
